export default __webpack_public_path__ + "static/media/city-guide-app.e4843bd0.png";